import { render, staticRenderFns } from "./EMWidgetHistogramChart.vue?vue&type=template&id=5b352189&scoped=true&"
import script from "./EMWidgetHistogramChart.vue?vue&type=script&lang=js&"
export * from "./EMWidgetHistogramChart.vue?vue&type=script&lang=js&"
import style0 from "./EMWidgetHistogramChart.vue?vue&type=style&index=0&id=5b352189&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b352189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VOverlay,VProgressCircular})
